export {
  STANDARD_IDENTIFIER_ALIASES,
  STANDARD_IDENTIFIER_CANONICALS,
  normalizeIdentifierHeader,
  type StandardIdentifierCanonical,
} from '../../../supabase/functions/_shared/resolveIdentifierColumn.ts';

export const DEFAULT_IDENTIFIER_LABELS = ['SKU', 'ASIN', 'GTIN', 'UPC'] as const;
